export const SET_TOGGLE_MODAL_PRODUCT = 'PURCHASE/SET_TOGGLE_MODAL_PRODUCT';
export const SET_TOGGLE_MODAL_PRICE_UPDATE = 'PURCHASE/SET_TOGGLE_MODAL_PRICE_UPDATE';
export const SET_TOGGLE_MODAL_IMPORT_XML = 'PURCHASE/SET_TOGGLE_MODAL_IMPORT_XML';
export const SET_TOGGLE_MODAL_MANIFESTED_XMLS = 'PURCHASE/SET_TOGGLE_MODAL_MANIFESTED_XMLS';
export const SET_LOADING_TAB_PRODUCT = 'PURCHASE/SET_LOADING_TAB_PRODUCT';
export const SET_LOADING_TAB_PURCHASE = 'PURCHASE/SET_LOADING_TAB_PURCHASE';
export const SET_TOGGLE_MODAL_CANCEL_PURCHASE = 'PURCHASE/SET_TOGGLE_MODAL_CANCEL_PURCHASE';
export const SET_MODAL_CANCEL_PURCHASE_IDS = 'PURCHASE/SET_MODAL_CANCEL_PURCHASE_IDS';
export const SET_TOGGLE_MODAL_CHANGE_CFOP = 'PURCHASE/SET_TOGGLE_MODAL_CHANGE_CFOP';
